<template>
  <InPlayerVideoOverlay>
    <OverlayContent>
      <template slot="title">
        😢 {{ $t('unable-to-load') }}
      </template>
      <template slot="message">
        {{ error && error.cause }}
      </template>
      <OverlayButton
        v-if="!isPlaybackBlocked"
        slot="content"
        :tracker="getAnalyticPayload(e => e.player['overlay-error-view'].click.refresh, $t('try-again'))"
        @click="performAction({
          fn: refresh,
          tracker: {
            label: 'try-again',
          },
        })"
      >
        {{ $t('try-again') }}
      </OverlayButton>
    </OverlayContent>
  </InPlayerVideoOverlay>
</template>

<script lang="ts">
import { getAnalyticPayload } from '@/scripts/libs/analytic';
import { VideoPlayerOverlayBase } from '../layout/VideoPlayerOverlayBase';
import InPlayerVideoOverlay from '../layout/InPlayerVideoOverlay.vue';
import { VideoBlockedError } from '@/scripts/store/modules/video/state/errors';
import OverlayContent from '../components/OverlayContent.ts.vue';
import OverlayButton from '../components/OverlayButton.ts.vue';

export default VideoPlayerOverlayBase.extend({
  i18n: {
    en: {
      'unable-to-load': 'Sorry, we can\'t load the film now.',
      'unable-to-play': 'This film is not available.',
      'try-again': 'Try again',
    },
    id: {
      'unable-to-load': 'Maaf, tidak dapat memuat film ini sekarang.',
      'unable-to-play': 'Film ini tidak dapat diputar.',
      'try-again': 'Coba lagi',
    },
    zh: {
      'unable-to-load': '抱歉，暫時無法加載這部短片。',
      'unable-to-play': '該短片無法播放。',
      'try-again': '重試',
    },
  },
  components: {
    InPlayerVideoOverlay,
    OverlayContent,
    OverlayButton,
  },
  computed: {
    isPlaybackBlocked(): boolean {
      return this.error?.error instanceof VideoBlockedError;
    },
  },

  methods: {
    refresh(): void {
      location.reload();
    },

    getAnalyticPayload,
  },
});
</script>
